// Serea PDP: gallery, bundles, upsell checkbox, add to cart, sticky bar, offer sync, carousels.
(function () {
const cartReady = () =>
window.SereaCart
? Promise.resolve(window.SereaCart)
: new Promise((resolve) => document.addEventListener('serea:cart-ready', () => resolve(window.SereaCart), { once: true }));
function formatMoney(cents, format) {
const fmt = format || '${{amount}}';
const value = (cents / 100).toFixed(2);
const noDecimals = Math.round(cents / 100).toString();
const withCommas = (v) => v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
return fmt
.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas(noDecimals))
.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
.replace(/\{\{\s*amount\s*\}\}/, withCommas(value));
}
function initGallery(root) {
const track = root.querySelector('[data-sr-track]');
if (!track) return;
const slides = Array.from(track.children);
const thumbs = Array.from(root.querySelectorAll('[data-sr-thumb]'));
const dots = Array.from(root.querySelectorAll('[data-sr-dot]'));
const setActive = (i) => {
thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
};
thumbs.forEach((t, i) =>
t.addEventListener('click', () => {
track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
setActive(i);
})
);
let raf;
track.addEventListener('scroll', () => {
cancelAnimationFrame(raf);
raf = requestAnimationFrame(() => {
const i = Math.round(track.scrollLeft / track.clientWidth);
setActive(Math.max(0, Math.min(slides.length - 1, i)));
});
}, { passive: true });
}
function initProduct(root) {
const dataEl = root.querySelector('[data-sr-product-json]');
if (!dataEl) return;
const data = JSON.parse(dataEl.textContent);
const moneyFormat = data.moneyFormat;
let variant = data.variants.find((v) => v.id === data.selectedVariantId) || data.variants[0];
const els = {
price: root.querySelectorAll('[data-sr-price]'),
was: root.querySelectorAll('[data-sr-was]'),
save: root.querySelectorAll('[data-sr-save]'),
atc: root.querySelector('[data-sr-atc]'),
atcLabel: root.querySelectorAll('[data-sr-atc-total]'),
error: root.querySelector('[data-sr-error]'),
upsell: root.querySelector('[data-sr-upsell]'),
upsellInput: root.querySelector('[data-sr-upsell-input]'),
sticky: document.querySelector(`[data-sr-sticky="${root.dataset.sectionId}"]`),
};
const upsell = data.upsell;
let upsellInCart = false;
const bundleEl = root.querySelector('[data-sr-bundle]');
function bundleOf(input) {
if (!input) return null;
const qty = parseInt(input.dataset.qty, 10) || 1;
const free = parseInt(input.dataset.free, 10) || 0;
const pct = parseFloat(input.dataset.pct) || 0;
return { qty, free, pct, units: qty + free };
}
// Mirrors Shopify: one % on the whole line (incl. free units), discount floored per unit.
const bundleTotal = (v, b) => {
const pnum = b.units * 100 - b.qty * (100 - b.pct);
const disc = Math.floor((v.price * pnum) / (b.units * 100) + 1e-9);
return (v.price - disc) * b.units;
};
function choiceTitle() {
const c = bundleEl && bundleEl.querySelector('input:checked');
const t = c && c.closest('.sr-bundle__opt') && c.closest('.sr-bundle__opt').querySelector('.sr-bundle__title');
return t ? t.textContent.trim() : '';
}
function selectedBundle() {
return bundleEl ? bundleOf(bundleEl.querySelector('input:checked')) : null;
}
const referenceCents = (v) => {
if (v.compare_at_price && v.compare_at_price > v.price) return v.compare_at_price;
if (data.referencePrice && data.referencePrice > v.price) return data.referencePrice;
return 0;
};
function upsellActive() {
return !!(upsell && els.upsellInput && els.upsellInput.checked && !upsellInCart);
}
function render() {
const ref = referenceCents(variant);
els.price.forEach((e) => (e.textContent = formatMoney(variant.price, moneyFormat)));
els.was.forEach((e) => {
e.textContent = ref ? formatMoney(ref, moneyFormat) : '';
e.hidden = !ref;
});
els.save.forEach((e) => {
if (ref) {
const pct = Math.round(((ref - variant.price) / ref) * 100);
e.textContent = (e.dataset.template || 'Save [percent]%').replace('[percent]', pct).replace('[amount]', formatMoney(ref - variant.price, moneyFormat));
}
e.hidden = !ref;
});
const b = selectedBundle();
const productTotal = b ? bundleTotal(variant, b) : variant.price;
const productWas = b ? variant.price * b.units : ref || variant.price;
const total = productTotal + (upsellActive() ? upsell.price : 0);
els.atcLabel.forEach((e) => (e.textContent = formatMoney(total, moneyFormat)));
const wasTotal = productWas + (upsellActive() ? upsell.ref || upsell.price : 0);
if (bundleEl) {
const unit = bundleEl.dataset.unit || 'unit';
bundleEl.querySelectorAll('.sr-bundle__opt').forEach((opt) => {
const input = opt.querySelector('input');
const ob = bundleOf(input);
opt.classList.toggle('is-selected', input.checked);
const t = bundleTotal(variant, ob);
const full = variant.price * ob.units;
const tEl = opt.querySelector('[data-sr-b-total]');
const fEl = opt.querySelector('[data-sr-b-full]');
const pEl = opt.querySelector('[data-sr-b-per]');
if (tEl) tEl.textContent = formatMoney(t, moneyFormat);
if (fEl) { fEl.hidden = !(full > t); fEl.textContent = formatMoney(full, moneyFormat); }
if (pEl) { pEl.hidden = ob.units < 2; pEl.textContent = formatMoney(Math.round(t / ob.units), moneyFormat) + ' / ' + unit; }
});
}
root.querySelectorAll('[data-sr-atc-was]').forEach((e) => {
e.hidden = !(wasTotal > total);
e.textContent = wasTotal > total ? formatMoney(wasTotal, moneyFormat) : '';
});
const available = variant.available;
root.querySelectorAll('[data-sr-atc], [data-sr-sticky-atc]').forEach((btn) => {
btn.disabled = !available;
const text = btn.querySelector('[data-sr-atc-text]');
if (text) text.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
});
if (els.sticky) {
const sb = els.sticky.querySelector('[data-sr-sticky-atc]');
if (sb) {
sb.disabled = !available;
const t = sb.querySelector('[data-sr-atc-text]');
if (t) t.textContent = available ? sb.dataset.labelAdd : sb.dataset.labelSoldout;
}
els.sticky.querySelectorAll('[data-sr-price]').forEach((e) => {
e.innerHTML = (wasTotal > total ? '<s style="opacity:.5;margin-right:6px">' + formatMoney(wasTotal, moneyFormat) + '</s>' : '') + formatMoney(total, moneyFormat);
});
const st = els.sticky.querySelector('.sr-sticky__title');
if (st) {
if (!st.dataset.base) st.dataset.base = st.textContent;
st.textContent = b && choiceTitle() ? choiceTitle() + (upsellActive() ? ' + eye patches' : '') : st.dataset.base;
}
}
document.querySelectorAll('[data-sr-offer]').forEach((o) => {
if (!b) return;
const set = (sel, fn) => o.querySelectorAll(sel).forEach(fn);
set('[data-sr-offer-now]', (e) => (e.textContent = formatMoney(productTotal, moneyFormat)));
set('[data-sr-offer-was]', (e) => { e.hidden = !(productWas > productTotal); e.textContent = formatMoney(productWas, moneyFormat); });
set('[data-sr-offer-save]', (e) => { const pct = productWas > productTotal ? Math.round(((productWas - productTotal) / productWas) * 100) : 0; e.hidden = !pct; e.textContent = 'Save ' + pct + '%'; });
set('[data-sr-offer-pill-now]', (e) => (e.textContent = formatMoney(total, moneyFormat)));
set('[data-sr-offer-pill-was]', (e) => { e.hidden = !(wasTotal > total); e.textContent = wasTotal > total ? formatMoney(wasTotal, moneyFormat) : ''; });
set('[data-sr-offer-choice]', (e) => { e.hidden = false; const t = e.querySelector('[data-sr-offer-choice-text]'); if (t) t.textContent = (choiceTitle() || '') + (upsellActive() ? ' + eye patches' : ''); });
});
if (els.upsell) {
els.upsell.classList.toggle('is-checked', upsellActive());
els.upsell.classList.toggle('is-in-cart', upsellInCart);
}
}
root.querySelectorAll('[data-sr-variant-input]').forEach((input) =>
input.addEventListener('change', () => {
const v = data.variants.find((x) => String(x.id) === input.value);
if (!v) return;
variant = v;
const url = new URL(window.location.href);
url.searchParams.set('variant', v.id);
window.history.replaceState({}, '', url.toString());
render();
})
);
if (els.upsellInput) {
els.upsellInput.addEventListener('change', render);
}
if (bundleEl) bundleEl.addEventListener('change', render);
async function syncUpsellWithCart(cart) {
if (!upsell) return;
try {
const c = cart || (await (await cartReady()).getCart());
upsellInCart = c.items.some((i) => i.variant_id === upsell.id);
if (els.upsellInput) {
els.upsellInput.disabled = upsellInCart;
if (upsellInCart) els.upsellInput.checked = false;
}
render();
} catch (e) {}
}
async function add(button) {
if (!variant.available) return;
if (els.error) els.error.classList.remove('is-visible');
const sb0 = selectedBundle();
const items = [{ id: variant.id, quantity: sb0 ? sb0.units : 1 }];
if (upsellActive()) items.push({ id: upsell.id, quantity: 1 });
const allButtons = [els.atc, els.sticky && els.sticky.querySelector('[data-sr-sticky-atc]')].filter(Boolean);
allButtons.forEach((x) => x.setAttribute('aria-busy', 'true'));
allButtons.forEach((x) => (x.disabled = true));
try {
const api = await cartReady();
const cart = await api.addItems(items, button);
await syncUpsellWithCart(cart);
} catch (e) {
if (els.error) {
els.error.textContent = e.message || els.error.dataset.fallback;
els.error.classList.add('is-visible');
}
} finally {
allButtons.forEach((x) => x.removeAttribute('aria-busy'));
allButtons.forEach((x) => (x.disabled = !variant.available));
}
}
if (els.atc) els.atc.addEventListener('click', () => add(els.atc));
// Bottom offer button follows the bundle chosen in the buy box.
document.querySelectorAll('[data-sr-offer] [data-sr-offer-atc]').forEach((btn) => {
btn.addEventListener('click', (ev) => {
if (!bundleEl) return;
ev.preventDefault();
ev.stopPropagation();
add(btn);
});
});
if (els.sticky) {
const sb = els.sticky.querySelector('[data-sr-sticky-atc]');
if (sb) sb.addEventListener('click', () => add(sb));
if (els.atc && 'IntersectionObserver' in window) {
const io = new IntersectionObserver(
([entry]) => {
const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
els.sticky.classList.toggle('is-visible', passed);
document.body.classList.toggle('sr-has-sticky', passed);
},
{ threshold: 0 }
);
io.observe(els.atc);
}
}
document.addEventListener('serea:cart-changed', () => syncUpsellWithCart());
render();
syncUpsellWithCart();
}
function initDelivery(scope) {
scope.querySelectorAll('[data-sr-delivery]').forEach((el) => {
const days = parseInt(el.dataset.days, 10) || 8;
const d = new Date();
d.setDate(d.getDate() + days);
el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
});
}
function initCarousels(scope) {
scope.querySelectorAll('[data-sr-carousel]').forEach((root) => {
if (root.dataset.srReady) return;
root.dataset.srReady = 'true';
const track = root.querySelector('[data-sr-track]');
if (!track) return;
const items = Array.from(track.children);
const dotsWrap = root.querySelector('[data-sr-dots]');
const step = () => (items[1] ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth);
const pages = () => Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1);
let dots = [];
const buildDots = () => {
if (!dotsWrap) return;
dotsWrap.innerHTML = '';
const n = pages();
dots = [];
if (n < 2) return;
for (let i = 0; i < n; i++) {
const b = document.createElement('button');
b.type = 'button';
b.className = 'sr-dots__dot';
b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
b.addEventListener('click', () => track.scrollTo({ left: i * step(), behavior: 'smooth' }));
dotsWrap.appendChild(b);
dots.push(b);
}
};
const update = () => {
const i = Math.round(track.scrollLeft / step());
dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
};
buildDots();
update();
track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
window.addEventListener('resize', () => { buildDots(); update(); });
const prev = root.querySelector('[data-sr-prev]');
const next = root.querySelector('[data-sr-next]');
if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
});
}
document.addEventListener('click', async (event) => {
const btn = event.target instanceof Element ? event.target.closest('[data-sr-quick-add]') : null;
if (!btn) return;
event.preventDefault();
if (btn.disabled) return;
btn.disabled = true;
try {
const api = await cartReady();
await api.addItems([{ id: btn.dataset.variantId, quantity: 1 }], btn);
} catch (e) {
console.warn('[serea] quick add failed', e);
} finally {
btn.disabled = false;
}
});
function boot() {
initDelivery(document);
initCarousels(document);
document.querySelectorAll('[data-sr-main]').forEach((root) => {
if (root.dataset.srReady) return;
root.dataset.srReady = 'true';
initGallery(root);
initProduct(root);
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
document.addEventListener('shopify:section:load', boot);
})();